import { TableColumnsType } from "antd";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";

export const servicepartnerTransferColumns: TableColumnsType<
  Partial<ServicePartner>
> = [
  { title: "Groep Naam", dataIndex: "groupName", key: "groupName" },
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (_: any, record) => (
      <a href={`/service-partners/partners/${record.id}`}>{record.name}</a>
    ),
  },
  {
    title: "Plaats",
    key: "city",
    render: (_: any, record) => record?.address?.city,
  },
];
